import {Dialog} from 'primereact/dialog'
import {Divider} from 'primereact/divider'
import {Tag} from 'primereact/tag'
import {forwardRef, useImperativeHandle, useMemo, useState} from 'react'
import {useParams} from 'react-router-dom/cjs/react-router-dom.min'
import {ReactComponent as DuoDizzyIcon} from '../../assets/icons/DuoDizzyIcon.svg'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'
import {useAuth} from '../authentication/AuthProvider'
import LatestTrendChart from './LatestTrendChart'
import {useUserSummary} from './query-keys/SummaryKeysManager'
import {summaryDataList} from './SummaryConstant'
const SummaryTable = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    //#region ID
    const {id: idString} = useParams()
    const id = useMemo(() => {
        return !!idString ? parseInt(idString) : null
    }, [idString])
    //#endregion

    //#region Context
    const {user} = useAuth()
    //#endregion

    //#region Translate
    const {translateCommons, translateDatatable} = TranslateUtils()
    //#endregion

    //#region State
    const [visible, setVisible] = useState(false)
    //#endregion

    //#region Query
    const {data: summaryData, refetch: refectSummary} = useUserSummary(
        user?.id,
        id,
        !!user?.id && !!id && !!visible,
    )
    //#endregion

    //#region Handle Function
    const handleShowForm = () => {
        blockOverflownScroll()
        setVisible(true)
    }

    const handleHideForm = () => {
        unblockOverflownScroll()
        setVisible(false)
    }
    //#endregion

    //#region Effect
    // useEffect(() => {
    //     if (!!user?.id && !!id) {
    //         refetchEvent.on('REFETCH-DATA-TABLE-Summary' + id, () => {
    //             refectSummary()
    //         })

    //         return () => {
    //             refetchEvent.removeListener('REFETCH-DATA-TABLE-Summary' + id)
    //         }
    //     }
    // }, [id, refectSummary, user])
    //#endregion

    return (
        <Dialog
            header={
                <div>
                    <span
                        className="text-teal-500"
                        style={{fontSize: '1.5rem', fontWeight: 'bold'}}>
                        {translateCommons('Summary')}
                    </span>
                    <p className="text-700 text-base font-medium  m-0 p-0">
                        {translateCommons(
                            "Summary tables can consolidate patient's health index results. This allows quick access to critical information during patient encounters, aiding in informed decision-making and improving patient safety.",
                        )}
                    </p>
                </div>
            }
            breakpoints={{'1550px': '80vw', '1080px': '100vw'}}
            style={{
                width: '60vw',
            }}
            visible={visible}
            onHide={handleHideForm}>
            <div className="w-full">
                <div className="col-12 p-2">
                    <h5s className=" flex align-items-center m-0 p-0">
                        {summaryData && summaryData?.recordedAt
                            ? `${translateCommons('Recorded at')} ${
                                  summaryData?.recordedAt
                              }`
                            : ''}
                    </h5s>

                    {/* <hr /> */}
                </div>
                <div className="col-12 p-0 border-round-2xl border-round-xl">
                    <div className="flex flex-wrap justify-content-center">
                        {summaryDataList?.map((summary, idx) => (
                            <div
                                key={idx}
                                className="grid align-items-stretch col-12 md:col-5 lg:col-4 sm:col-6">
                                <div className="border-1 border-gray-100 border-round w-full">
                                    {/* Label & Icon */}

                                    <div className="grid align-items-start h-full">
                                        {/* Text */}
                                        <div
                                            // className={`${
                                            //     summary?.key !==
                                            //     'levelOfConsciousness'
                                            //         ? 'col-12 md:col-5 lg:col-4 px-4'
                                            //         : 'col-12 '
                                            // }`}
                                            className="col-12 p-0">
                                            {summary?.key !==
                                                'levelOfConsciousness' && (
                                                <div className="w-full p-2">
                                                    <div className="flex align-items-center">
                                                        <div className="mr-2">
                                                            {summary?.icon}
                                                        </div>
                                                        <p className="text-lg">
                                                            {translateCommons(
                                                                summary?.label,
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                            {/* Stat */}
                                            <div className="w-full px-6 mt-4 justify-content-center text-center">
                                                {summaryData ? (
                                                    summary?.key ===
                                                    'levelOfConsciousness' ? (
                                                        <div className="flex col-12 p-0">
                                                            <div className="flex flex-column justify-content-between col-12 lg:col-6 border-none lg:border-right-1 p-0">
                                                                <div className="w-full p-2">
                                                                    <div className="flex align-items-center justify-content-center w-full">
                                                                        <div className="">
                                                                            {
                                                                                summary?.icon
                                                                            }
                                                                        </div>
                                                                        <p className="">
                                                                            {translateCommons(
                                                                                summary?.label,
                                                                            )}{' '}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                {/* <h4
                                                                    className={`mb-0 text-center font-bold`}>
                                                                    {translateDatatable(
                                                                        summaryData[
                                                                            'levelOfConsciousnessValue'
                                                                        ],
                                                                    )}
                                                                </h4> */}
                                                                <Tag
                                                                    value={translateDatatable(
                                                                        summaryData[
                                                                            'levelOfConsciousnessValue'
                                                                        ],
                                                                    )}
                                                                    className="px-3 text-white text-sm font-bold rounded-full"
                                                                    style={{
                                                                        backgroundColor:
                                                                            '#ffbb00ff',
                                                                        width: '4rem',
                                                                        height: '2rem',
                                                                        fontSize:
                                                                            '1rem',
                                                                        textAlign:
                                                                            'center',
                                                                    }}
                                                                />
                                                            </div>

                                                            <Divider layout="vertical" />

                                                            <div className="flex flex-column justify-content-between align-items-center col-12 lg:col-6 p-0">
                                                                <div className="w-full p-2">
                                                                    <div className="flex align-items-center justify-content-center w-full">
                                                                        <div className="mr-2">
                                                                            <DuoDizzyIcon
                                                                                style={{
                                                                                    height: '24px',
                                                                                    width: '24px',
                                                                                    color: '#D10363',
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <p>
                                                                            {translateCommons(
                                                                                'Confusion',
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                {!!summaryData[
                                                                    'confusion'
                                                                ] ? (
                                                                    <Tag
                                                                        value={translateCommons(
                                                                            'Yes',
                                                                        )}
                                                                        className="px-3 text-white text-sm font-bold rounded-full"
                                                                        style={{
                                                                            backgroundColor:
                                                                                '#ff0000ff',
                                                                            width: '4rem',
                                                                            height: '2rem',
                                                                            fontSize:
                                                                                '1rem',
                                                                            textAlign:
                                                                                'center',
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <Tag
                                                                        value={translateCommons(
                                                                            'No',
                                                                        )}
                                                                        className=" text-white font-bold rounded-full"
                                                                        style={{
                                                                            backgroundColor:
                                                                                '#09bb03ff',
                                                                            width: '4rem',
                                                                            height: '2rem',
                                                                            fontSize:
                                                                                '1rem',
                                                                            textAlign:
                                                                                'center',
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <h1
                                                            className={`mb-0 font-bold`}>
                                                            {((!!summaryData[
                                                                summary?.key
                                                            ] ||
                                                                summaryData[
                                                                    summary?.key
                                                                ] === 0) &&
                                                                `${
                                                                    summaryData[
                                                                        summary
                                                                            ?.key
                                                                    ]
                                                                }`) ||
                                                                '-'}
                                                            {summary?.unit &&
                                                            (!!summaryData[
                                                                summary?.key
                                                            ] ||
                                                                summaryData[
                                                                    summary?.key
                                                                ] === 0) ? (
                                                                <span className="text-base text-500">
                                                                    {` `}
                                                                    {
                                                                        summary.unit
                                                                    }
                                                                </span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </h1>
                                                    )
                                                ) : (
                                                    <h1 className={`mb-0 `}>
                                                        -
                                                    </h1>
                                                )}
                                            </div>

                                            {/* Chart */}
                                            {summary.key !==
                                                'levelOfConsciousness' && (
                                                <div className="w-full mt-2">
                                                    {!!summary?.isChart
                                                        ? summaryData?.dataPoint &&
                                                          !!summaryData
                                                              ?.dataPoint[
                                                              summary?.key
                                                          ] &&
                                                          summaryData
                                                              ?.dataPoint[
                                                              summary?.key
                                                          ]?.length > 0 && (
                                                              <LatestTrendChart
                                                                  summary={
                                                                      summary
                                                                  }
                                                                  dataPoint={
                                                                      summaryData
                                                                          ?.dataPoint[
                                                                          summary
                                                                              ?.key
                                                                      ] || []
                                                                  }
                                                              />
                                                          )
                                                        : ''}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* <div className="mt-3 col-12">
                    <Button
                        className="col-12 p-button-lg p-button-outlined"
                        label={translateCommons('CLOSE')}
                        icon="pi pi-times"
                        onClick={handleHideForm}
                    />
                </div> */}
            </div>
        </Dialog>
    )
})

export default SummaryTable
